import { Controller } from "stimulus"

export default class extends Controller {
  static values = { content: String }

  copy() {
    const textarea = document.createElement("textarea")
    textarea.value = this.contentValue
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    this.showFeedback()
  }

  showFeedback() {
    const originalText = this.element.textContent
    this.element.textContent = "Copied!"
    setTimeout(() => {
      this.element.textContent = originalText
    }, 2000)
  }
}
